import { Grid, Link, Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect } from "react";
import { ReactComponent as CheckMark } from "../../assets/images/svg/check_mark.svg";

const option = [
  {
    id: "1",
    header: "Register:",
    text: "Create an account using your email address, or register through an existing Salesforce or Google account.",
    verified: false,
  },
  {
    id: "2",
    header: "Select Solution:",
    text: "Select the solution you would like to try based on which department you’d like to incorporate social impact funds into typical transactions with buyers or sellers.",
    verified: false,
  },
  {
    id: "3",
    header: "Complete Account Setup:",
    text: "Activate your trial by confirming your company name and details.",
    verified: false,
  },
];

const errorOptions = [
  {
    header: "Buywith",
    text: "Incorporate social impact funds into bids and RFPs to align with the right buyers, and accelerate meeting your company’s CSR and ESG commitments.",
    id: "data:image/png;base64,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",
    verified: false,
  },
  {
    header: "Sellwith",
    text: "Incorporate social impact funds into sales proposals to show more value to your prospects and customers, and accelerate meeting your company’s CSR and ESG commitments.",
    id: "data:image/png;base64,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",
    verified: false,
  },
];

interface Props {
  steps?: any;
  showError?: boolean;
  activeId?: number;
}

const LeftBox: React.FC<Props> = ({ steps, showError, activeId }) => {
  const is1550 = useMediaQuery("(max-width:1550px)");
  // const options = showError ? errorOptions : option;
  const options = option;

  useEffect(() => {
    console.log("steps   ", JSON.stringify(steps));
    steps &&
      steps.forEach((step: any) => {
        option[step.stepIndex].verified =
          activeId !== 0 ? true : step.isActivated;
      });
  }, [steps, activeId]);

  return (
    <Grid
      sx={{
        display: "grid",
        gap: showError ? '60vh' : '40px',
        position: "relative",
        minHeight: "100vh",
      }}
    >
      {!showError && (
        <>
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "50px",
              color: "#FFFFFF",
              display: "flex",
              justifyContent: "left",
              marginX: "105px",
            }}
          >
            Welcome to
          </Typography>
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "40px",
              color: "#FFFFFF",
              marginX: "105px",
              marginTop: "-40px",
            }}
          >
            The Community AI
          </Typography>
        </>
      )}
      <Box>
        {!showError &&
          options.map((item, i) => (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {!showError ? (
                  <Typography
                    sx={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "60px",
                      backgroundColor: "#004660",
                      border: `2px solid ${
                        item.verified ? "#28ABE2" : "#005778"
                      }`,
                      display: "flex",
                      justifyContent: "center",
                      alignContent: "center",
                      color: "#FFFFFF",
                      fontSize: "36px",
                      flexWrap: "wrap",
                      margin: "4px",
                    }}
                  >
                    {item.verified ? (
                      <CheckMark width="32px" height="32px" />
                    ) : (
                      item.id
                    )}
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      border: "solid 2px rgba(102, 189, 240, 0.2)",
                      borderRadius: "10px",
                      background: "rgba( 39,107,161, 0.2)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "4.76em",
                      padding: "0em 1.5em",
                    }}
                  >
                    <img src={`${item.id}`} />
                  </Typography>
                )}
                {options.length - 1 !== i && !showError && (
                  <Box
                    sx={{
                      border: `2px ${
                        item.verified ? "solid #7DD4EA" : "dashed #276BA1"
                      } `,
                      height: "calc(100% - 72px)",
                    }}
                  ></Box>
                )}
              </Box>
              <Box
                sx={{
                  marginLeft: "15px",
                  width: `${is1550 ? "60%" : "350px"}`,
                  paddingBottom: option.length - 1 !== i ? "30px" : "0px",
                }}
              >
                <Typography sx={{ fontSize: "22px", fontWeight: 700 }}>
                  {item.header}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "16px",
                    marginTop: "16px",
                    fontWeight: 400,
                    lineHeight: "21.79px",
                  }}
                >
                  {item.text}
                </Typography>
              </Box>
            </Box>
          ))}
      </Box>
      {!showError ? (
        <Typography
          sx={{
            color: "#FFFFFF",
            justifyItems: "center",
            textAlign: "center",
            padding: "0px 10%",
            fontWeight: "400",
            fontSize: "16px",
          }}
        >
          <Box sx={{ bottom: 0 }}>
            Questions? Contact&nbsp;
            <Link
              href="mailto:help@communityimpact.ai"
              style={{ color: "#337ab7", fontWeight: 700, fontSize: "16px" }}
            >
              help@communityimpact.ai
            </Link>{" "}
            to learn more about the value of The CommunityAI's solutions before
            creating an account, or to set up a live demo.
          </Box>
        </Typography>
      ) : (
        <Box
          sx={{
            bottom: 0,
            width: "95%",
            backgroundColor: "#2b3656b3",
            padding: "30px 15px 30px 28px",
          }}
        >
          <Typography
            sx={{
              fontWeight: "800",
              fontSize: "36px",
              color: "#FFFFFF",
              display: "flex",
              justifyContent: "left",
              lineHeight: "49.03px",
              marginBottom: "0.5em",
            }}
          >
            Aligning people, profits, and planet to make change!
          </Typography>
          <Typography
            sx={{
              color: "#FFFFFF",
              fontWeight: "600",
              fontSize: "20px",
              justifyContent: "left",
              lineHeight: "27.24px",
            }}
          >
            Build social impact funding into every deal, as powerful sales and procurement incentives for both buyers and sellers.
          </Typography>
        </Box>
      )}
    </Grid>
  );
};

export default LeftBox;
